import React from 'react'
import PropTypes from 'prop-types'

import { Bag } from './../block/Svg'

class Main extends React.Component {
  render() {
    const { assets_path, width } = this.props

    return (
      <div
        className='bg-cover bg-center bg-no-repeat pb-[50px]'
        style={{ backgroundImage: `url(/${assets_path}/images/cartbg.svg)` }}
      >
        <div className='container leading-none'>
          {width > 500 ?
            <div className='relative'>
              <a href="/" className='absolute top-[34px] left-[24px]'>
                <svg width="27" height="11" viewBox="0 0 27 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M0.215912 4.89926C-0.0715065 5.18668 -0.0715065 5.65268 0.215912 5.94009L4.89966 10.6238C5.18708 10.9113 5.65308 10.9113 5.94049 10.6238C6.22791 10.3364 6.22791 9.87043 5.94049 9.58301L1.77716 5.41968L5.94049 1.25635C6.22791 0.968927 6.22791 0.502931 5.94049 0.215513C5.65308 -0.0719056 5.18708 -0.0719056 4.89966 0.215513L0.215912 4.89926ZM0.736328 5.41968V6.15566H26.7363V5.41968V4.6837H0.736328V5.41968Z" fill="white"/>
                </svg>
              </a>
              <img src={`/${assets_path}/images/about/bg.png`} width={900} height={508} className='h-auto w-full rounded-b-[20px]' alt="okidoki" />
            </div>
          :
            <div className='relative'>
              <a href="/" className='absolute top-[34px] left-[24px]'>
                <svg width="27" height="11" viewBox="0 0 27 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M0.215912 4.89926C-0.0715065 5.18668 -0.0715065 5.65268 0.215912 5.94009L4.89966 10.6238C5.18708 10.9113 5.65308 10.9113 5.94049 10.6238C6.22791 10.3364 6.22791 9.87043 5.94049 9.58301L1.77716 5.41968L5.94049 1.25635C6.22791 0.968927 6.22791 0.502931 5.94049 0.215513C5.65308 -0.0719056 5.18708 -0.0719056 4.89966 0.215513L0.215912 4.89926ZM0.736328 5.41968V6.15566H26.7363V5.41968V4.6837H0.736328V5.41968Z" fill="white"/>
                </svg>
              </a>
              <img src={`/${assets_path}/images/about/bgm.png`} width={375} height={508} className='h-auto w-[calc(100%+20px)] max-w-[none] ml-[-10px] rounded-b-[20px]' alt="okidoki" />
            </div>
          }
          <div className='mt-[24px] text-center text-[24px] font-semibold text-black'>Немного об — ОкиДоки!</div>
          <div className='w-full bg-white rounded-[25px] px-[15px] py-[20px] mt-[19px]'>
            <div className='text-center text-[18px] font-medium text-black mb-[10px]'>
              Наш ресторан – это<br />
              <span className='text-[#5A91FF]'>больше, чем просто еда</span>
            </div>
            <div className='text-[14px] text-[#00000099] mb-[15px] text-center'>
              Здесь рождаются кулинарные истории, которыми гордятся повара и любят гости. Каждое блюдо, будь то нежная пицца, изысканные роллы, пикантные суши, аутентичные блюда китайской кухни или сытные бургеры, готовится с душой и любовью.
            </div>
            <div className='text-[14px] text-[#00000099] mb-[15px] text-center'>
              Приглашаем присоединиться к семейному кругу ОкиДоки, ведь здесь важна каждая деталь, каждый гость и каждый опыт.
            </div>
            <div className='text-[14px] text-[#00000099] mb-[15px] text-center'>
              В ресторане «Оки Доки» представлен огромный ассортимент блюд, которые включают в себя элементы китайской, японской и итальянской кухни.
            </div>
            <div className='text-[14px] text-[#00000099] text-center'>
              Благодаря старательной работе поваров, в «Оки Доки» могут удовлетворить потребности и запросы самых требовательных гурманов.
            </div>
          </div>
          <div className='mt-[30px] text-center text-[24px] font-semibold text-black'>У нас можно попробовать почти все кухни мира</div>
          <div className='w-[100%] p-[10px] pl-[0px] bg-white rounded-[25px] flex mt-[19px] gap-[10px]'>
            <div className='relative flex-none'>
              <div className='absolute h-[20px] rounded-full px-[10px] top-0 left-[10px] metka-shadow text-white text-[10px] flex items-center bg-[#A6DD2F]'>Хит</div>
              <img src={`/${assets_path}/images/about/bludo.png`} alt="Салат" width={147} height={133} className='w-[150px] h-[auto]' />
            </div>
            <div class="flex-1">
              <div class="text-black block text-[18px] font-medium mb-[7px] z-0 mt-[10px]"><span class="relative">Салат с хрустящими баклажанами</span></div>
              <div class="text-[14px] text-[#00000099] line-clamp-4">Баклажан, крахмал кукурузный, соевый соус, чеснок, кунжут, сыр сливочный.</div>
            </div>
          </div>
          <a 
            className="flex flex-1 items-center gap-[9px] h-[50px] p-[5px] rounded-full cursor-pointer bg-[#5A91FF] bluebtn-shadow w-[100%] mt-[15px]"
            href="/"
          >
            <div className='flex flex-none items-center justify-center w-[40px] h-[40px] rounded-full bg-[#FFFFFF40]'>
              <Bag />
            </div>
            <div className='text-[16px] flex flex-1 items-center justify-around gap-[5px] me-[12px] text-nowrap tracking-tight text-white'>
              <div className='flex items-center gap-[8px]'>
                <div>Перейти к выбору еды</div>
              </div>
            </div>
          </a>
          <div className='mt-[30px] text-center text-[24px] font-semibold text-black'>Почему именно Окидоки?</div>
          <div className='w-full bg-white rounded-[25px] px-[15px] py-[20px] mt-[20px]'>
            <div className='text-center text-[18px] font-medium text-black mb-[10px]'>
              Качественные <span className='text-[#5A91FF]'>продукты</span>
            </div>
            <div className='text-[14px] text-[#00000099] text-center'>
              Каждый продукт проходит строгий контроль качества перед попаданием на кухню. Мы знаем цену качеству и верим, что хорошее сырье создает отличную еду.
            </div>
          </div>
          <div className='w-full bg-white rounded-[25px] px-[15px] py-[20px] mt-[20px]'>
            <div className='text-center text-[18px] font-medium text-black mb-[10px]'>
              Уникальное <span className='text-[#5A91FF]'>сочетание<br />традиций и новаторства</span>
            </div>
            <div className='text-[14px] text-[#00000099] text-center'>
              Мы любим экспериментировать, соединяя классику итальянской, японской и американской кухонь с традициями Востока. Ты можешь выбрать любимый сет или создать собственный микс – любые желания выполнимы.
            </div>
          </div>
          <div className='w-full bg-white rounded-[25px] px-[15px] py-[20px] mt-[20px]'>
            <div className='text-center text-[18px] font-medium text-black mb-[10px]'>
              Идеальная <span className='text-[#5A91FF]'>подача и атмосфера</span>
            </div>
            <div className='text-[14px] text-[#00000099] text-center'>
              От заказа до доставки, от улыбки курьера до горячего бокала чая – каждая мелочь продумана нами для твоего комфорта. Любые пожелания учтены заранее, даже самые смелые фантазии воплотимы.
            </div>
          </div>
          <div className='w-full bg-white rounded-[25px] px-[15px] py-[20px] mt-[20px]'>
            <div className='text-center text-[18px] font-medium text-black mb-[10px]'>
              Постоянное <span className='text-[#5A91FF]'>развитие</span>
            </div>
            <div className='text-[14px] text-[#00000099] text-center'>
              Команда ОкиДоки неустанно совершенствует рецепты, оптимизирует процессы приготовления и расширяет ассортимент. Будь готов удивляться новым блюдам и сочетаниям вкусов!
            </div>
          </div>
          <div className='mt-[30px] w-full'>
            <img src={`/${assets_path}/images/about/team.svg`} width={64} height={64} alt="User" className='mx-auto' />
            <div className='bg-[#5A91FF] rounded-[25px] p-[15px] text-white mt-[-14px] text-center'>
              <div className='text-[24px] font-semibold'>Присоединяйся к нашему сообществу гурманов!</div>
              <div className='mt-[10px] text-[#FFFFFFAB] text-[14px]'>Выбирай любимые блюда и наслаждайся ими дома, в офисе или на прогулке. Мы рады каждому гостю и готовы подарить незабываемый гастрономический опыт!</div>
            </div>
          </div>
          <div className='mt-[30px] text-center text-[24px] font-semibold'>Приятного аппетита и до новых встреч в ресторане</div>
          <img src={`/${assets_path}/images/about/btm.svg`} alt="okidoki" width={135} height={54} className='mx-auto mt-[10px]' />
        </div>
      </div>
    )
  }
}

Main.propTypes = {
  assets_path: PropTypes.string,
  width: PropTypes.number
}

export default Main